import { render, staticRenderFns } from "./audiences-manage.vue?vue&type=template&id=2baed2d9&scoped=true&"
import script from "./audiences-manage.vue?vue&type=script&lang=js&"
export * from "./audiences-manage.vue?vue&type=script&lang=js&"
import style0 from "./audiences-manage.vue?vue&type=style&index=0&id=2baed2d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baed2d9",
  null
  
)

export default component.exports